import React from 'react';

import { styled } from '@mui/material/styles';

import {Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
import { CardContent } from '@mui/material';

const PREFIX = 'ConcurExpenseTracker';
const classes = {};

const Root = styled('div')({
	// table: {
	//     minWidth: 500,
	// }
});

const ConcurExpenseTracker = ({concurUrl, isModal}) => {


	return (
        <Root style={{ 
			width: '100%', 
			height: '100%',
			padding: '0px',
			margin: '0px',
			overflow: 'hidden',
		}}>
            {concurUrl ? (
				<iframe
					src={concurUrl}
					style={{ 
						width: '100%', 
						height: '100%', 
						border: 'none',
						margin: '0px',
						padding: '0px',
						display: 'block'
					}}
					title="Embedded Content"
					allowFullScreen
				/>
			): (
				<Typography variant="h6" color="textSecondary" align="center" style={{ fontSize: '1.32rem' }}>
					If you are having issues viewing the Job Cost Expense Tracker, try accessing the main Power BI website at <a href="https://app.powerbi.com/?pbi_source=websignin_uNav" target="_blank" rel="noreferrer">https://app.powerbi.com/?pbi_source=websignin_uNav</a>. Once you confirm your account, refresh the page and try again. If issues persist, please contact us at <a href="mailto:innovation@arcomurray.com?subject=PHD Feedback" target="_blank">innovation@arcomurray.com</a>.
				</Typography>
			)}
        </Root>
    );
};

export default ConcurExpenseTracker;
